export type TruncationReceipt = {
  text: string;
  truncated: boolean;
};

/**
 * Truncate a string to a maximum length, adding an ellipsis if necessary.
 * Returns a TruncationReceipt object, with information about the truncation.
 */
export const truncationReceipt = (
  text: string,
  maxLength: number,
  ellipsis = "…",
): TruncationReceipt => {
  const trimmed = text.trim();

  if (text.length <= maxLength) {
    return { text: trimmed, truncated: text.length !== trimmed.length };
  }

  // Subtract ellipsis length to make sure we stay under limit
  const end = maxLength - ellipsis.length;

  if (end < 1) {
    return { text: "", truncated: true };
  }

  return { text: trimmed.substring(0, end).trim() + ellipsis, truncated: true };
};

/** Truncate a string to a maximum length, adding an ellipsis if necessary */
export const truncate = (
  text: string,
  maxLength: number,
  ellipsis = "…",
): string => {
  const { text: truncatedText } = truncationReceipt(text, maxLength, ellipsis);
  return truncatedText;
};
